<template>
  <ul class="actions-container">
    <li>
      <button
        @click="e => handleAction(e, 'bold')"
        :class="options.isBoldDisabled ? 'disabled' : ''"
        aria-label="Bold"
        class="text-format-button pure-button"
        tabindex="0"
      >
        <svg v-html="svg.boldSvg" aria-label="Bold" height="50" role="img" width="50"></svg>
      </button>
    </li>
    <li>
      <button
        @click="e => handleAction(e, 'italic')"
        :class="options.isItalicDisabled ? 'disabled' : ''"
        aria-label="Italic"
        class="text-format-button pure-button"
        tabindex="0"
      >
        <svg v-html="svg.italicSvg" aria-label="Italic" height="50" role="img" width="50"></svg>
      </button>
    </li>
    <li>
      <button
        @click="e => handleAction(e, 'underline')"
        :class="options.isUnderlineDisabled ? 'disabled' : ''"
        aria-label="Underline"
        class="text-format-button pure-button"
        tabindex="0"
      >
        <svg
          v-html="svg.underlineSvg"
          aria-label="Underline"
          height="50"
          role="img"
          width="50"
        ></svg>
      </button>
    </li>
    <slot></slot>
  </ul>
</template>
<script>
import boldSvg from 'assets/svg/text-formatting-section/text-formatting-bold.svg';
import italicSvg from 'assets/svg/text-formatting-section/text-formatting-italic.svg';
import underlineSvg from 'assets/svg/text-formatting-section/text-formatting-underline.svg';

export default {
  props: {
    options: {
      type: Object,
      iRequired: true
    }
  },
  data() {
    return {
      svg: {
        boldSvg,
        italicSvg,
        underlineSvg
      }
    };
  },
  methods: {
    handleAction(event, action) {
      const { boldCallback, italicCallback, underlineCallback } = this.options;
      switch (action) {
        case 'bold':
          if (boldCallback) {
            boldCallback(event);
          }
          break;
        case 'italic':
          if (italicCallback) {
            italicCallback(event);
          }
          break;
        case 'underline':
          if (underlineCallback) {
            underlineCallback(event);
          }
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.actions-container {
  display: flex;
  flex-flow: row nowrap;
  list-style: none;
  margin: 0px;
  padding: 0px;

  li {
    display: inline-block;

    .text-format-button {
      display: inline-block;
      cursor: pointer;
      margin-right: 1.25em;
      padding: 0px;

      &.disabled {
        opacity: 0.5;
        cursor: default;
        pointer-events: none;
      }
    }
  }
}
</style>
